/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC, useMemo } from "react";
import { capitalizeFirstLetter } from "../../utils/utils";
import GoogleIcon from "../../assets/icons/google-ic.svg";
import AppleIcon from "../../assets/icons/apple-ic.svg";
import MicrosoftIcon from "../../assets/icons/microsoft-icon.svg";
import FacebookIcon from "../../assets/icons/facebook-ico.svg";
import LaddaButton from "./LaddaButton";

export enum SocialProvider {
  GOOGLE = "google",
  FACEBOOK = "facebook",
  MICROSOFT = "microsoft",
  APPLE = "apple",
  AZURE = "azure",
}

interface ConnectButtonProps {
  type: SocialProvider;
  disabled?: boolean;
  className?: string;
  lable?: string;
  onConnect: () => void;
}

export const ConnectButton: FC<ConnectButtonProps> = ({
  type,
  onConnect,
  className = "",
  disabled = false,
  lable = "Connect",
}) => {
  const getIcon = useMemo(() => {
    switch (type) {
      case SocialProvider.GOOGLE:
        return GoogleIcon;
      case SocialProvider.APPLE:
        return AppleIcon;
      case SocialProvider.FACEBOOK:
        return FacebookIcon;
      case SocialProvider.MICROSOFT:
        return MicrosoftIcon;
      default:
        return null;
    }
  }, [type]);

  return (
    <>
      <LaddaButton
        className={`btn btn-social text-center d-flex flex-center p-tb-xs border ${className}`}
        disabled={disabled}
        type="button"
        onClickHandler={() => {
          onConnect();
        }}
        btnName={
          <>
            <span>
              {lable} with {capitalizeFirstLetter(type)}
            </span>
            <img className="m-l-xxs pb-1" src={getIcon} alt={type} />
          </>
        }
      />
    </>
  );
};
